import Theme from "src/styles/Theme";
import Router from "./routes/Router";
import { ToastContainer } from "react-toastify";

function App() {
	return (
		<Theme>
			<Router />
			<ToastContainer />
		</Theme>
	);
}

export default App;
